import { Card, CardContent, Box, CardMedia, Typography } from '@mui/material';
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";


class IbssNoEventCard extends IbssComponent<IProps, IState>
{

    public render(): JSX.Element
    {
        return (
            <Card sx={{ display: 'flex' }}>
                <CardMedia
                    component="img"
                    sx={{ width: 160, minWidth: 160, height: 130, objectFit: 'contain' }}
                    image={this.props.image}
                    alt="event img"
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center' }}>
                    <CardContent className="card-botom-spacing-0">
                        <Typography variant="h6" color="textSecondary">{this.props.title}</Typography>
                    </CardContent>
                </Box>
            </Card >
        );
    }

}

export default IbssNoEventCard;

interface IProps 
{
    title: string;
    image: string;
}

interface IState
{
}
